<template>
  <div>
    <div v-if="isLoading" class="text-center pt-5">
      <circle8></circle8>
    </div>
    <div v-else>
      <div class="container">
        <div class="row justify-content-center">
          <div class="card col-5 col-sm-5 col-md-3 col-lg-3 col-xl-2 card-container" v-for="row in maskData" >
            <h5 class="store-name">{{row.name}}</h5>
            <h5 :class="['store-remains',
             'mb-3',
             (row.remain_stat === 'plenty' ? 'text-info' : ''),
             (row.remain_stat === 'some' ? 'text-success' : ''),
             (row.remain_stat === 'few' ? 'text-warning' : ''),
             (row.remain_stat === 'empty' ? 'text-muted' : ''),
             (row.remain_stat === null ? 'null' : '')]">{{row.remain_stat || '정보없음'}}</h5>
            <h6 class="store-address mb-2">{{row.addr}}</h6>
            <p class="card-text text-muted">재고 추가 시간<br/>{{row.stock_at}}</p>
            <a v-bind:href="'https://m.map.naver.com/search2/search.nhn?query=' + row.name" class="btn btn-primary btn-outline">정보보기</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import axios from 'axios';
import moment from 'moment';
import Constants from '../constants';
import {
  RotateSquare3, Stretch, Circle8
} from 'vue-loading-spinner'

export default {
  name: 'List',
  data () {
    return {
      responseData: {},
      maskData: [],
      dateList: [],
      isLoading: false,
    }
  },
  components: {
    Circle8
  },
  watch:{
    $route () {
    },
  },
  mounted () {
    this.getMaskList(this.$route.query.lat, this.$route.query.lng);
  },
  methods : {
    getMaskList: function(lat, lng) {
      axios
        .get(Constants.ENDPOINT + '?lat=' + lat + '&lng=' + lng + "&m=1000")
        .then(response => {
          console.log(response.data);
          this.responseData = response.data;
          this.maskData = this.responseData.stores;
        });
    },
    changeDay: function(date) {
      this.$router.push("/menu/" + this.$route.params.code + "/" + date);
      this.selectedDate = this.$route.params.date;
    },
    changeMealType: function(type) {
      let _thisRef = this;
      this.isLoading = true;
      setTimeout(function() {
        _thisRef.selectedMealType = type;
        _thisRef.menuData = _thisRef.responseData[type];
        _thisRef.isLoading = false;
      }, 500);

    }
  }
}
</script>

<style scoped>
  .card-container {
    padding: 13px;
    margin: 10px;
  }

  .store-name {
    font-size: 20px;
  }

  .store-remains {
    font-size: 20px;
    font-weight: bold;
  }

  .store-address {
    font-style: italic;
  }

  .card-text {
    color: #464646;
  }

  .card-body {
    padding: 0;
  }

  .btn-group {
    margin-bottom: 0;
  }

  .alert {
    margin-top: 20px;
  }

  .btn:focus, .btn:active {
    outline: none !important;
    box-shadow: none !important;
  }

  .spinner--circle-8 {
    margin: 10% auto auto;
  }

  .plenty {
    color: forestgreen;
  }

  .some {
    color: orange;
    /*color: #cfb422;*/
  }

  .few {
    color: red;
  }

  .empty {
    color: lightgrey;
  }

  .null {
    color: lightgrey;
  }

</style>



// WEBPACK FOOTER //
// src/components/List.vue